(function(angular) {
    'use strict';

    angular.module('aprima-facility-api').factory('FacilitySecurityRepository', [
        'AprimaAnalytics',
        'AprimaRestangular', 
        FacilitySecurityRepository
    ]);

    function FacilitySecurityRepository(
        AprimaAnalytics,
        AprimaRestangular
    ) {
        return {
            postChangePassword: postChangePassword,
        };

        function postChangePassword(changePasswordDto) {
            var timing = AprimaAnalytics.startTiming('FacilitySecurityRepository', 'api', 'postChangePassword');
            var restangular = AprimaRestangular.get('facility');
            return restangular.one('security', changePasswordDto.Id)
                              .post('changepassword', changePasswordDto)
                              .finally(timing.stop);
        }
    }
})(window.angular);